import { $ } from './dom';
import { toast } from './toast';

/*
 * Installing CraftStudio as an app (PWA): an icon on the home screen that opens full screen.
 *   public/manifest.webmanifest   name, icons, full screen ("standalone")
 *   public/sw.js                  keeps nothing in a cache; lets phones offer installing; explains a failed load offline
 *   "บัญชีของฉัน" › ติดตั้งเป็นแอป  Android/Chrome: a button that installs; iPhone/iPad: how to add it (Apple lets
 *                                 only the person do it, from the share menu)
 */

interface InstallPrompt extends Event { prompt(): Promise<void>; userChoice: Promise<{ outcome: 'accepted' | 'dismissed' }> }

const standalone = () => matchMedia('(display-mode: standalone)').matches || (navigator as Navigator & { standalone?: boolean }).standalone === true;
const apple = () => /iPhone|iPad|iPod/.test(navigator.userAgent) || (/Macintosh/.test(navigator.userAgent) && navigator.maxTouchPoints > 1);

export function initInstallApp() {
  let prompt: InstallPrompt | null = null;
  let workerError = '';

  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.register('/sw.js').catch(e => { workerError = e instanceof Error ? e.message : String(e); paint(); });
  } else workerError = 'เบราว์เซอร์นี้ไม่รองรับการติดตั้งเป็นแอป';

  window.addEventListener('beforeinstallprompt', e => { e.preventDefault(); prompt = e as InstallPrompt; paint(); });
  window.addEventListener('appinstalled', () => { prompt = null; toast('ติดตั้ง CraftStudio แล้ว เปิดได้จากไอคอนบนหน้าจอ'); paint(); });

  const btn = $<HTMLButtonElement>('acInstall');
  function paint() {
    const text = $('acInstallText');
    btn.hidden = true;
    if (standalone()) { text.textContent = 'เปิดเป็นแอปอยู่แล้ว (จากไอคอนบนหน้าจอ)'; return; }
    if (prompt) { btn.hidden = false; text.textContent = 'ติดตั้งแล้วจะมีไอคอน CraftStudio บนหน้าจอ เปิดเต็มจอเหมือนแอป'; return; }
    if (apple()) {
      text.textContent = 'iPhone/iPad: กดปุ่มแชร์ (สี่เหลี่ยมมีลูกศรชี้ขึ้น) ของเบราว์เซอร์ › เลือก "เพิ่มไปยังหน้าจอโฮม" › กด "เพิ่ม" '
        + 'แล้วเปิดจากไอคอน ครั้งแรกต้องเข้าสู่ระบบในแอปอีกครั้ง (แอปบนหน้าจอโฮมแยกการเข้าสู่ระบบจากเบราว์เซอร์) '
        + 'ข้อดีเพิ่ม: เครื่องจะเก็บคลิปวิดีโอที่เตรียมไว้ได้นานกว่า';
      return;
    }
    text.textContent = (workerError ? `ติดตั้งจากปุ่มนี้ไม่ได้ (${workerError}) ` : '')
      + 'เปิดเมนูของเบราว์เซอร์ (⋮ หรือ ⋯) แล้วเลือก "ติดตั้งแอป" หรือ "เพิ่มไปยังหน้าจอหลัก"';
  }

  btn.onclick = async () => {
    if (!prompt) { paint(); return; }
    const p = prompt;
    prompt = null;
    try {
      await p.prompt();
      const { outcome } = await p.userChoice;
      if (outcome === 'dismissed') toast('ยกเลิกการติดตั้งแล้ว ติดตั้งภายหลังได้จากเมนูนี้');
    } catch (e) {
      toast('เปิดหน้าต่างติดตั้งไม่ได้: ' + (e instanceof Error ? e.message : String(e)), true);
    }
    paint();
  };

  return { paint };
}
